.header-container {
    position: relative;
    background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
    min-height: 180px;
    border-radius: 8px 0 0 0;
    overflow: hidden;
    display: flex;
    align-items: center;
}

.matrix-container {
    position: absolute;
    inset: 0;
    overflow: hidden;
    opacity: 0.15;
    pointer-events: none;
}

.matrix-column {
    position: absolute;
    top: -100%;
    display: flex;
    flex-direction: column;
    font-family: 'SF Mono', Monaco, 'Consolas', monospace;
    font-size: 14px;
    color: #22c55e;
    line-height: 1.2;
    animation: matrix-fall linear infinite;
    text-shadow: 0 0 8px #22c55e;
}

.matrix-column span {
    display: block;
}

@keyframes matrix-fall {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(300%);
    }
}

.header-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding: 24px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
}

.text-section {
    flex: 1;
    min-width: 0;
}

.debug-badge {
    display: inline-block;
    padding: 3px 10px;
    background: rgba(239, 68, 68, 0.2);
    border: 1px solid rgba(239, 68, 68, 0.4);
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #f87171;
    margin-bottom: 8px;
}

.title {
    margin: 0 0 8px 0;
    font-family:
        'Doyle',
        -apple-system,
        BlinkMacSystemFont,
        'Segoe UI',
        sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: #f1f5f9;
    line-height: 1.2;
}

.subtitle {
    margin: 0;
    font-size: 14px;
    color: #94a3b8;
    line-height: 1.5;
    max-width: 500px;
}

.illustration-section {
    flex-shrink: 0;
    opacity: 0.9;
}

@media (max-width: 768px) {
    .header-content {
        flex-direction: column;
        text-align: center;
    }

    .illustration-section {
        display: none;
    }

    .subtitle {
        max-width: none;
    }
}
